import * as Sentry from '@sentry/react';

export const isMobile = () => !!(
    navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
);

export const sendGAEvent = (
    action: string,
    category: string = null,
    label: string = null,
    value: string = null
) => gtag(
    'event',
    action, {
        'event_category': category,
        'event_label': label,
        'value': value
    }
);

export enum ACTION {
    ONELINK = 'onelink'
}

export const initSentry = () => Sentry.init({
  dsn: window.namespaceEnv === 'production' ? 'https://73250166ef5dc7b629d05d13f2dcd445@sentry.banksalad.com/16' : 'https://b8ef35ad3e2316482644bc699f5eed27@sentry-v2.staging.banksalad.com/27',
});
